import { ThemeKey } from "@smartsheet/design-tokens";
import { getClientId } from "@smartsheet/lodestar-utils";
import React, { FC } from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { InputFieldBaseProps } from "../../../../util/inputFieldBaseProps";
import { FocusMode } from "../../../focusMode";
import { TextInputProps } from "../../../textinput";
import { DatePickerTextInputPlaceholderStyled } from "../styled/DatePickerTextInputPlaceholderStyled";

export interface DatePickerTextInputPlaceholderProps extends InputFieldBaseProps {
    clientId: string | undefined;
    focusMode: FocusMode;
    format: string;
    isFocused: boolean;
    validationState: "error" | undefined;
    value: string;
    id?: string;
    variant?: TextInputProps["variant"];
}

export const DatePickerTextInputPlaceholder: FC<DatePickerTextInputPlaceholderProps> = ({
    clientId,
    format,
    validationState,
    value,
    isFocused,
    focusMode,
    variant = "box",
    ...rest
}) => {
    const { key } = useTheme();
    const themeMode = key as ThemeKey;

    return (
        <DatePickerTextInputPlaceholderStyled
            data-client-id={getClientId(clientId, "dp-input-placeholder")}
            themeMode={themeMode}
            validationState={validationState}
            isFocused={isFocused}
            focusMode={focusMode}
            variant={variant}
            {...rest}
        >
            <span className="sds__user-input">{value}</span>
            <span className="sds__format-placeholder">{format.substring(value.length)}</span>
        </DatePickerTextInputPlaceholderStyled>
    );
};
